import React from "react";
import rotateTablet from "../../assets/images/png/rotateTablet.png";
import Header from "../Header/Header";

const OrientationScreenForTab = () => {
  return (
    <>
      <Header isLogoNavigationEnabled={false} />
      <div className="orientation_screen_for_tablet">
        <img src={rotateTablet} alt="Rotate Tablet" />
        <span className="rotate_tablet_text">Rotate your Tablet</span>
        <span className="rotate_tablet_sub_text">
          Please view the application in a landscape mode for a better
          Experience
        </span>
      </div>
    </>
  );
};

export default OrientationScreenForTab;
